/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_By_Name_Or_Email_PlaceholderInputs */

const en_search_by_name_or_email_placeholder = /** @type {(inputs: Search_By_Name_Or_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search by name or email...`)
};

const es_search_by_name_or_email_placeholder = /** @type {(inputs: Search_By_Name_Or_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar por nombre o correo...`)
};

/**
* | output |
* | --- |
* | "Search by name or email..." |
*
* @param {Search_By_Name_Or_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_by_name_or_email_placeholder = /** @type {((inputs?: Search_By_Name_Or_Email_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_By_Name_Or_Email_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_by_name_or_email_placeholder(inputs)
	return es_search_by_name_or_email_placeholder(inputs)
});